module.exports = __webpack_public_path__ + "media/images/emblems/Monthey_VS-9cf859879886f26365c9b6194709acab.png";